import { AppInjector } from 'src/app/core/services/app-injector.service';
import { TournamentService } from '../../../tournament.service';

export default class TabBase {
    protected tournamentService: TournamentService;
    constructor() {
        const injector = AppInjector.getInjector();
        this.tournamentService = injector.get(TournamentService);
    }
}
